import { Player } from '../../jscaip/Player';
import { TableUtils } from '../../jscaip/TableUtils';
import { KamisadoColor } from './KamisadoColor';
import { KamisadoPiece } from './KamisadoPiece';
export class KamisadoBoard {
    static INITIAL = KamisadoBoard.getInitialBoard();
    static SIZE = 8;
    static COLORS = TableUtils.map([
        [1, 2, 3, 4, 5, 6, 7, 8],
        [6, 1, 4, 7, 2, 5, 8, 3],
        [7, 4, 1, 6, 3, 8, 5, 2],
        [4, 3, 2, 1, 8, 7, 6, 5],
        [5, 6, 7, 8, 1, 2, 3, 4],
        [2, 5, 8, 3, 6, 1, 4, 7],
        [3, 8, 5, 2, 7, 4, 1, 6],
        [8, 7, 6, 5, 4, 3, 2, 1],
    ], KamisadoColor.of);
    static getColorAt(x, y) {
        return KamisadoBoard.COLORS[y][x];
    }
    static getInitialBoard() {
        const _ = KamisadoPiece.EMPTY;
        return [
            [1, 2, 3, 4, 5, 6, 7, 8].map((value) => KamisadoPiece.of(Player.ONE, value)),
            [_, _, _, _, _, _, _, _],
            [_, _, _, _, _, _, _, _],
            [_, _, _, _, _, _, _, _],
            [_, _, _, _, _, _, _, _],
            [_, _, _, _, _, _, _, _],
            [_, _, _, _, _, _, _, _],
            [8, 7, 6, 5, 4, 3, 2, 1].map((value) => KamisadoPiece.of(Player.ZERO, value)),
        ];
    }
}
